module.exports = __webpack_public_path__ + "img/base_frame.a6b9e8df.png";